module.exports = __webpack_public_path__ + "static/media/bureau_2.d287b0c0.png";